import React from "react";
import { Box } from "@mui/material";
import { IconTooltip } from "@metacrm/metacrm-material-ui/dist/IconTooltip";
import { useTheme } from "@mui/styles";
import { formatNumberWithComma } from "features/helpers/utils";
import Grid from "@metacrm/metacrm-material-ui/dist/Grid";
import Percent from "components/Percent/Percent";
import { StyledSkeleton } from "components/LoadingComponent/LoadingComponent.styles";
import { useIntl } from "react-intl";

const DataBlock = ({ data, isLoading, ...otherProps }) => {
  const { formatMessage } = useIntl();
  const { dataTitle, tooltipText, number, totalNumber, rate, isEmpty } = data;
  const theme = useTheme();

  let percentData;

  const dataTitleMap = {
    "New Participants": formatMessage({
      id: "communityAnalysis.metrics.newParticipants",
    }),
    Engagements: formatMessage({ id: "communityAnalysis.metrics.engagements" }),
    "Unified Retention Rate": formatMessage({
      id: "communityAnalysis.metrics.unifiedRetentionRate",
    }),
    "Retention Rate": formatMessage({
      id: "communityAnalysis.metrics.retentionRate",
    }),
    "Unique Wallet Count": formatMessage({
      id: "global.metrics.uniqueWallet",
    }),
    Transactions: formatMessage({
      id: "global.metrics.transaction",
    }),
    "Avg. Transactions": formatMessage({ id: "global.metrics.transactionAvg" }),
  };

  if (rate === "-" || rate === null || rate === undefined) {
    percentData = "-";
  } else if (typeof rate === "string") {
    // 檢查字串是否可以轉換為數字
    if (!isNaN(Number(rate))) {
      percentData = Number(rate).toFixed(2);
    } else {
      percentData = "-";
    }
  } else if (typeof rate === "number") {
    percentData = rate.toFixed(2);
  } else {
    percentData = "-";
  }

  return (
    <Box
      sx={{
        background: theme.customColors.white,
        borderRadius: "4px",
        padding: "16px 16px 8px",
        height: "80px",
      }}
      {...otherProps}>
      <Box
        sx={{
          color: theme.customColors.grey[700],
          fontSize: "16px",
          display: "flex",
          alignItems: "center",
          marginBottom: "8px",
          marginRight: "4px",
        }}>
        {isEmpty ? (
          <StyledSkeleton
            animation="wave"
            sx={{ width: "30%", minWidth: "150px" }}
          />
        ) : (
          <>
            {" "}
            {dataTitleMap[dataTitle] ?? "-"}
            <Box
              sx={{
                marginLeft: "4px",
                display: "inline-flex",
                alignItems: "center",
              }}>
              <IconTooltip content={tooltipText} />
            </Box>
          </>
        )}
      </Box>

      {isLoading ? (
        <StyledSkeleton
          animation="wave"
          sx={{ height: "24px", width: "80%" }}
        />
      ) : (
        <Box
          display={"flex"}
          alignItems={"flex-end"}
          justifyContent={"space-between"}>
          <Box display={"flex"} alignItems={"flex-end"}>
            <Box
              sx={{
                fontSize: "24px",
                fontWeight: 700,
                marginRight: "4px",
                color: theme.customColors.grey[700],
              }}>
              {formatNumberWithComma(number)}
            </Box>

            {totalNumber && (
              <Box
                sx={{
                  fontSize: "18px",
                  color: theme.customColors.grey[500],
                  display: "flex",
                }}>
                <Box sx={{ marginRight: "4px" }}>/</Box>{" "}
                {formatNumberWithComma(totalNumber)}
              </Box>
            )}
          </Box>

          <Box ml="auto">
            <Percent data={percentData} />
          </Box>

          {/* {rate && (
          <Box
            sx={{ color: theme.customColors.green[500], marginLeft: "auto" }}
          >
            <i className="meta-crm-icon-ic_up font-size-12" />
            {formatNumberWithComma(rate)}%
          </Box>
        )} */}
        </Box>
      )}
    </Box>
  );
};

export default DataBlock;
